/** Rows per page on the legacy lists built on `Table`. */
export const ROWS_PER_PAGE = 15;

export const handleFilterChange = (type, value, setFilter) => {
  setFilter((prevState) => ({ ...prevState, [type]: value, page: 1 }));
};

/**
 * The `Table` `onSort` handler for a legacy list: writes the clicked column's
 * `sortField` and the direction into the list's filter state, keeping the page
 * the admin is on.
 *
 * `page` is the list's current page, read at click time. `orderKey` is the key
 * the list's request reads the direction from: `sortOrder` for most lists,
 * `order` for the user lists and the multi-day jobs list.
 *
 * Returns the sort fields it wrote, for a list that also mirrors them into the URL.
 */
export const handleOnSort = (
  selectedColumn,
  sortDirection,
  setFilter,
  { page, orderKey = 'sortOrder' },
) => {
  const sortObj = {
    page,
    sortField: selectedColumn.sortField,
    [orderKey]: sortDirection,
  };

  setFilter((prevState) => ({
    ...prevState,
    ...sortObj,
  }));

  return sortObj;
};
